import * as actionTypes from "../actionTypes";
import axios from "../../../services/axios";
import {setMessage} from "../message";
import {loadApplicationReport, onLoadApplicationReportStopped, saveApplicationReport} from "./dormitory";

export const loadProfilingRating = () => {
    return {
        type: actionTypes.LOAD_PROFILING_RATING
    }
}

export const loadProfilingQueueApplications = () => {
    return {
        type: actionTypes.LOAD_PROFILING_QUEUE_APPLICATIONS
    }
}

export const loadProfilingSpecialities = () => {
    return {
        type: actionTypes.LOAD_PROFILING_SPECIALITIES
    }
}

export const setProfilingRating = (profilingRating) => {
    return {
        type: actionTypes.SET_PROFILING_RATING,
        profilingRating: profilingRating
    }
}

export const setProfilingQueueApplications = (profilingQueueApplications) => {
    return {
        type: actionTypes.SET_PROFILING_QUEUE_APPLICATIONS,
        profilingQueueApplications: profilingQueueApplications
    }
}

export const setProfilingSpecialities = (profilingSpecialities) => {
    return {
        type: actionTypes.SET_PROFILING_SPECIALITIES,
        profilingSpecialities: profilingSpecialities
    }
}

const createProfilingApplicationRequest = () => {
    return {
        type: actionTypes.CREATE_PROFILING_APPLICATION_REQUEST
    };
};

const createProfilingApplicationSuccess = (payload) => {
    return {
        type: actionTypes.CREATE_PROFILING_APPLICATION_SUCCESS,
        payload: payload
    };
};

const createProfilingApplicationFailure = (error) => {
    return {
        type: actionTypes.CREATE_PROFILING_APPLICATION_FAILURE,
        error: error
    };
};

const updateProfilingApplicationRequest = () => {
    return {
        type: actionTypes.UPDATE_PROFILING_APPLICATION_REQUEST
    };
};

const updateProfilingApplicationRequestSuccess = (payload) => {
    return {
        type: actionTypes.UPDATE_PROFILING_APPLICATION_REQUEST_SUCCESS,
        payload: payload
    };
};

const updateProfilingApplicationRequestFailure = (error) => {
    return {
        type: actionTypes.UPDATE_PROFILING_APPLICATION_REQUEST_FAILURE,
        error: error
    };
};

export const getProfilingRating = () => {
    return (dispatch) => {
        dispatch(loadProfilingRating())
        axios.get(`/api/v1/profiling-rating`)
            .then(response => {
                dispatch(setProfilingRating(response.data))
            })
            .catch(error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            });
    }
}

export const getProfilingQueueApplications = () => {
    return (dispatch) => {
        dispatch(loadProfilingQueueApplications())
        axios.get(`/api/v1/profiling-queue/applications`)
            .then(response => {
                dispatch(setProfilingQueueApplications(response.data))
            })
            .catch(error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            });
    }
}

export const createProfilingApplication = (specialityId) => {
    return (dispatch) => {
        dispatch(createProfilingApplicationRequest());
        axios
            .post(`/api/v1/profiling-queue/create-application?id=${specialityId}`)
            .then((response) => {
                dispatch(setMessage({type: 'success', text: "Заявка успешно подана."}))
                dispatch(createProfilingApplicationSuccess(response.data));
            })
            .catch((error) => {
                dispatch(setMessage({type: 'error', text: "Не удалось подать заявку."}))
                dispatch(createProfilingApplicationFailure(error));
            });
    };
};

export const updateProfilingApplication = (applicationId, specialityId) => {
    return (dispatch) => {
        dispatch(updateProfilingApplicationRequest());
        axios.patch(`/api/v1/profiling-queue/update-specialization`, {
            applicationId: applicationId,
            specialityId: specialityId
        })
            .then((response) => {
                dispatch(setMessage({type: 'success', text: "Заявка успешно изменена."}));
                dispatch(updateProfilingApplicationRequestSuccess(response.data));
            })
            .catch((error) => {
                dispatch(setMessage({type: 'error', text: "Не удалось изменить заявку."}));
                dispatch(updateProfilingApplicationRequestFailure(error));
            });
    };
};

export const getProfilingSpecialities = () => {
    return (dispatch) => {
        dispatch(loadProfilingSpecialities())
        axios.get(`/api/v1/profiling-queue/specializations`)
            .then(response => {
                dispatch(setProfilingSpecialities(response.data))
            })
            .catch(error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            });
    }
}

export const downloadProfilingApplicationExcel = (profilingApplicationId) => {
    return (dispatch) => {
        dispatch(loadApplicationReport())
        axios.get(`/api/v1/profiling-queue/download-excel?profiling-application-id=${profilingApplicationId}`,
            {
                responseType: 'blob',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }
            }
        ).then(response => {
            dispatch(saveApplicationReport(response))
        }).catch(error => {
            dispatch(setMessage({type: 'error', text: "Не удалось скачать заявление."}))
            dispatch(onLoadApplicationReportStopped())
        });
    }
}
